exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  width: 100%;\n  background-color: white;\n  color: #5B6779;\n  border-radius: 5px 5px 0 0;\n  border: 1px solid #BABBC7;\n  border-bottom: none; }\n\nspan {\n  display: inline-block;\n  padding: 5px 10px 3px 20px;\n  font-size: 12px; }\n  span.completed {\n    background-color: #CBDB29;\n    color: white; }\n  span.active {\n    color: #5B6779; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/progress-bar/progress-bar.scss
// module id = ../../../../../src/app/shared/components/progress-bar/progress-bar.scss
// module chunks = 12